/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MeResponse } from '../../models/me-response';

export interface AuthMe$Json$Params {
}

export function authMe$Json(http: HttpClient, rootUrl: string, params?: AuthMe$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<MeResponse>> {
  const rb = new RequestBuilder(rootUrl, authMe$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MeResponse>;
    })
  );
}

authMe$Json.PATH = '/api/v1/auth/me';
